import { arcTeamService } from './arcTeamService'

/**
 * The arc-team module façade. No store: the team pages load the team they display, and the member
 * lists belong to arcTeamMemberModule.
 */
export const useArcTeam = () => {
  return {
    arcTeam: {
      service: arcTeamService()
    }
  }
}
